import { render, staticRenderFns } from "./PreviewForm3.vue?vue&type=template&id=5f6bc13e&scoped=true"
import script from "./PreviewForm3.vue?vue&type=script&lang=ts"
export * from "./PreviewForm3.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6bc13e",
  null
  
)

export default component.exports